import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
export default class RightWhiteArrow extends Component {
    render() {
        return (_jsx("svg", Object.assign({ width: "16", height: "15", viewBox: "0 0 16 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.10519 0L7.30505 1.68169L12.2603 6.31087L0.0585937 6.31087L0.0585937 8.68913L12.2603 8.68913L7.30505 13.3183L9.10519 15L15.1663 9.32493C16.2214 8.33705 16.2214 6.66295 15.1663 5.67507L9.10519 0Z", fill: "white" }, void 0) }), void 0));
    }
}
